<template>
  <div class="mc-catalog">
    <Gender></Gender>
    <div v-if="brandLoading" class="mc-loader">
      <span class="mc-loader__circle"></span>
    </div>
    <div v-if="brandError" class="mc-error">{{ brandError }}</div>
    <div v-if="brandLoaded" class="mc-brands">
      <template v-for="item in brand">
        <router-link :to="`/category/brand_${item.id}/`" class="mc-brands_item">
          <img :src="item.image" :alt="item.name" />
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Gender from "@/views/blocks/Gender.vue";

export default {
    beforeRouteLeave(to, from) {
        //if (to.name != 'login')
        //  this.$store.dispatch('unLoader');
    },
    created() {
      // Загружаем категории только если они еще не были загружены
      this.fetchBrand();
    },
    computed: {
      ...mapGetters([
        'user',
        'brand',
        'brandLoading',
        'brandError',
        'brandLoaded',
        'gender'
      ])
    },
    async mounted() {
      // Можно добавить дополнительную логику при необходимости
    },
    watch: {
      gender(newValue, oldValue) {
        if (oldValue && oldValue != newValue) {
          this.fetchBrand();
        }
      }
    },
    methods: {
      ...mapActions([
        'fetchBrand'
      ])
    },
    data: () => ({

    }),
    components: {
      Gender,
    }
}
</script>
